// Paints the article row's scrollbar only while the row is actually moving.
// CSS cannot tell "being scrolled" from "scrollable", so the class comes from here;
// snippets/product-related-articles.liquid holds the two states.
//
// A file rather than a {% javascript %} block in the snippet: Shopify compiles those
// only from SECTIONS. A snippet's block is dropped from compiled_assets/scripts.js
// without a word — see theme/docs/GOTCHAS.md.
//
// One capturing listener on the document rather than one per row: `scroll` does not
// bubble, and capture also covers a row the theme editor re-rendered after load.
(function () {
  var IDLE_MS = 900;

  document.addEventListener(
    'scroll',
    function (event) {
      var row = event.target;
      if (!row || !row.classList) return;
      if (!row.classList.contains('product-related-articles__grid--scroll')) return;

      row.classList.add('is-scrolling');
      window.clearTimeout(row.braIdleTimer);
      row.braIdleTimer = window.setTimeout(function () {
        row.classList.remove('is-scrolling');
      }, IDLE_MS);
    },
    true
  );
})();
